export default {
  activeSection: '',
  activeSectionLink: '',
  isScrolling: false,
};
